import { makeStyles, Tab, Tabs } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SalesQuickView from 'scenes/Producer/MySales/components/Quickview';
import Tour from 'v2/components/Shared/Tour';
import { useModal } from 'v2/hooks/useModal';
import subscriptionsService from 'v2/services/subscriptions';

import type { ISubscriptionInvoice, ISubscriptions } from 'v2/interfaces/subscriptions';

import Details from './Details';
import Filter from './Filter';
import { initialFilter } from './Filter/interfaces';
import List from './List';
import QuickView from './Quickview';
import { steps } from './tour';

const useStyles = makeStyles(() => ({
  content: {
    marginTop: 16,
  },
  tabs: {
    borderBottom: '1px solid #d8d8d8',
    marginBottom: 16,
  },
  tab: {
    minWidth: 110,
  },
}));

export type ISubscriptionTabs = 'psl' | 'contracts';

const Subscriptions = memo(() => {
  const classes = useStyles();
  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [tab, setTab] = useState<ISubscriptionTabs>('contracts');
  const [visibleQuickView, setVisibileQuickView] = useModal();
  const [visibleQuickViewInvoice, setVisibileQuickViewInvoice] = useModal();

  const [currentSubscription, setCurrentSubscription] = useState<ISubscriptions>(null);
  const [currentInvoice, setCurrentInvoice] = useState<ISubscriptionInvoice>(null);

  const shouldOpenPslTab = !!searchParams.get('isPsl');

  const handleSetCurrentSubscription = useCallback(
    (subscription: ISubscriptions) => {
      setVisibileQuickView();
      setCurrentSubscription(subscription);
    },
    [setVisibileQuickView]
  );

  const handeCloseQuickView = useCallback(() => {
    setVisibileQuickView();
    setTimeout(() => setCurrentSubscription(null), 100);
  }, [setVisibileQuickView]);

  const handleSetCurrentInvoice = useCallback(
    (invoice: ISubscriptionInvoice) => {
      setVisibileQuickViewInvoice();
      setCurrentInvoice(invoice);
    },
    [setVisibileQuickViewInvoice]
  );

  const handeCloseQuickViewInvoice = useCallback(() => {
    setVisibileQuickViewInvoice();
    setTimeout(() => setCurrentInvoice(null), 100);
  }, [setVisibileQuickViewInvoice]);

  const handleChange = useCallback((_: React.ChangeEvent<{}>, tab: ISubscriptionTabs) => {
    const isUnlimitedInstallment = tab === 'psl';
    subscriptionsService.setFilter({ ...initialFilter, unlimited_installment: isUnlimitedInstallment });
    subscriptionsService.setResetForm(true);
    setTab(tab);
  }, []);

  useEffect(() => {
    if (shouldOpenPslTab) setTab('psl');
  }, [shouldOpenPslTab]);

  return (
    <>
      <Tour name='mysubscriptions_tour' steps={steps} />
      <QuickView contract={currentSubscription} onClose={handeCloseQuickView} isOpen={visibleQuickView} />
      <SalesQuickView showRefund={false} sale={currentInvoice} onClose={handeCloseQuickViewInvoice} open={visibleQuickViewInvoice} isSubscription />

      <div>
        <Grid id='my-subscriptions' container justify='space-between' alignItems='flex-start'>
          <div className='my-title'>
            <h1>Meus Contratos</h1>
            <p>Gerencie seus contratos e parcelamento sem limite.</p>
          </div>
        </Grid>

        <div className='m32' />

        <div>
          <Tabs className={classes.tabs} onChange={handleChange} value={tab} indicatorColor='primary' textColor='primary'>
            <Tab className={classes.tab} value='contracts' label='Contratos' />
            <Tab className={classes.tab} value='psl' label='Parcelamento sem limites' />
          </Tabs>

          <Filter tab={tab} />
          <Details />
          <List handleSetCurrentSubscription={handleSetCurrentSubscription} handleSetCurrentInvoice={handleSetCurrentInvoice} />
        </div>
      </div>
    </>
  );
});

export default Subscriptions;
